"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaults = {};
var _default = defaults;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJkZWZhdWx0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1R5cGUvdHlwb2dyYXBoeS1jb250ZXh0LWRlZmF1bHRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgVHlwb2dyYXBoeUNvbnRleHRWYWx1ZSB9IGZyb20gJy4vVHlwb2dyYXBoeUNvbnRleHQnO1xuXG5jb25zdCBkZWZhdWx0czogVHlwb2dyYXBoeUNvbnRleHRWYWx1ZSA9IHt9O1xuXG5leHBvcnQgZGVmYXVsdCBkZWZhdWx0cztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRUEsSUFBTUEsUUFBZ0MsR0FBRyxDQUFDLENBQUM7QUFBQyxlQUU3QkEsUUFBUTtBQUFBIn0=